import React from "react";
const IconShippingIllustration = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none" {...props}>
    <circle cx="17" cy="38.5" r="4.5" stroke="currentColor" strokeWidth="2" />
    <circle cx="40" cy="38.5" r="4.5" stroke="currentColor" strokeWidth="2" />
    <path d="M21.5 37H35.5" stroke="currentColor" strokeWidth="2" />
    <path
      d="M12.6622 37L9.5 37L9.5 14L32.6892 14L32.6892 18.7045M32.6892 37L32.6892 18.7045M32.6892 18.7045L41.1216 18.7045L43.2297 26.0227L48.5 28.1136L48.5 37L44.2838 37"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <path d="M17.5 14H24.5V23L21 20.75L17.5 23V14Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
export default IconShippingIllustration;
